import { createContext } from 'react';
import PropTypes from 'prop-types';

export const FormContext = createContext({
    submit: PropTypes.func,
});
